import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SpaIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    title={t`Spa`}
    {...props}
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1 7c0 6.125 4.375 7 7 7s7-.875 7-7"
      fill="none"
    />
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 14c0-2.625 2.625-7 7-7M8 14c0-2.625-2.625-7-7-7M5.5 6c.133-.833 1-3 2.5-3s2.367 1.833 2.5 3"
      fill="none"
    />
  </Icon>
);
